import * as types from './mutation-types'
import changeTime from '@/common/js/userCenter/base.js'
// import {playMode} from '../common/js/config'
// import {shuffle} from '../common/js/util'

function findIndex (list, growthItem) {
  return list.findIndex((item) => {
    return item.id === growthItem.id
  })
}
// 更新StudyExperience
export const updateStoreStudyExperience = function ({commit, state}, form) {
  form = changeTime(form) // 转换成年月日的模式
  let studyArr = state.studyExperience.slice()
  let index = findIndex(studyArr, form)
  studyArr.splice(index, 1, form)
  commit(types.SET_STUDY_EXPERIENCE, studyArr)
}
// 删除StudyExperience
export const deleteStoreStudyExperience = function ({commit, state}, form) {
  // form = changeTime(form)
  let studyArr = state.studyExperience.slice()
  let index = findIndex(studyArr, form)
  studyArr.splice(index, 1)
  commit(types.SET_STUDY_EXPERIENCE, studyArr)
}

// 更新workExperience
export const updateStoreWorkExperience = function ({commit, state}, form) {
  form = changeTime(form) // 转换成年月日的模式
  let workArr = state.workExperience.slice()
  let index = findIndex(workArr, form)
  workArr.splice(index, 1, form)
  commit(types.SET_WORK_EXPERIENCE, workArr)
}
// 删除workExperience
export const deleteStoreWorkExperience = function ({commit, state}, form) {
  let workArr = state.workExperience.slice()
  let index = findIndex(workArr, form)
  workArr.splice(index, 1)
  commit(types.SET_WORK_EXPERIENCE, workArr)
}
// export const addStoreStudyExperience = function ({commit, state}, form) {
//   form = changeTime(form) // 转换成年月日的模式
//   let studyArr = state.studyExperience.slice()
//   studyArr.push(form)
//   commit(types.SET_STUDY_EXPERIENCE, studyArr)
// }
// export const addStoreWorkExperience = function ({commit, state}, form) {
//   form = changeTime(form) // 转换成年月日的模式
//   let workArr = state.workExperience.slice()
//   workArr.push(form)
//   commit(types.SET_WORK_EXPERIENCE, workArr)
// }



// WEBPACK FOOTER //
// ./src/store/actions.js